import { Component, OnInit } from '@angular/core';
import { IntegrationModel, IntegrationPlatformType } from 'app/integrations/models/integration.model';
import { IntegrationsService } from 'app/integrations/integration.service';
import { Observable } from 'rxjs';
import { IntegrationPlatformSpecificsFactory } from '../integration-platform-specifics.factory';
import { Subscription } from '../../shared/models/plans';
import { AccountSettingsService } from '../../my-account/account-settings.service';
import { Ng1ModalService } from '../../shared/ng1/ng1-modal.service';
import { Router } from '@angular/router';
import { flatMap } from 'rxjs/operators';

@Component({
  selector: 'cc-integration-list',
  templateUrl: './integration-list.component.html',
  styleUrls: ['./integration-list.component.scss']
})
export class IntegrationListComponent implements OnInit {
  integrationStatuses$: Observable<IntegrationModel[]>;
  public subscription$: Observable<Subscription>;
  public isFreePlan: boolean;

  constructor(
    private accountSettingsService: AccountSettingsService,
    private integrationService: IntegrationsService,
    private specificsFactory: IntegrationPlatformSpecificsFactory,
    private ng1ModalService: Ng1ModalService,
    private router: Router
  ) {}

  ngOnInit() {
    this.integrationStatuses$ = this.integrationService.checkIntegrationStatuses();
    this.subscription$ = this.accountSettingsService.getSubscription();
    this.subscription$.subscribe(plans => {
      const plan = plans.licenses[0].planName;
      this.isFreePlan = plan === 'Free' ? true : false;
    });
  }

  platform(integration: IntegrationModel) {
    return integration.platformType.toString().toLocaleLowerCase();
  }

  connectIcon(integration: IntegrationModel): string {
    const { customConnectIcon } = this.specificsFactory.getSpecifics(integration.platformType);
    const defaultIcon = integration.integrated
      ? 'assets/img/channels/success-integration.svg'
      : 'assets/img/channels/add-plus.svg';
    return customConnectIcon || defaultIcon;
  }
}
